import { getConfig } from '@/lib/config'
import { ItemType } from '@/shared/api-generated-types'
import * as Sentry from '@sentry/nextjs'

const {
  publicRuntimeConfig: {
    graphqlApi: { url },
  },
} = getConfig()

export interface AddBookmarkProps {
  itemId: string
  itemType: ItemType
}

export async function addBookmark({ itemId, itemType }: AddBookmarkProps): Promise<object | boolean> {
  try {
    const mutationBody = {
      query: `
        mutation CreateBookmark($input: CreateBookmarkInput!) {
          createBookmark(input: $input) {
            success
          }
        }
        `,
      variables: {
        input: {
          itemId,
          itemType,
        },
      },
    }
    const response: any = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(mutationBody),
    })
    const parsedResponse = await response.json()
    if (parsedResponse.errors) throw new Error(JSON.stringify(parsedResponse.errors))

    return parsedResponse
  } catch (err) {
    // Log this error to sentry but dont panic.
    console.error('Failed to add bookmark from gsu-web', err)
    Sentry.captureException(err)
    return false
  }
}

export async function removeBookmark(itemId: string): Promise<object | boolean> {
  try {
    const mutationBody = {
      query: `
        mutation RemoveBookmark($input: RemoveBookmarkInput!) {
          removeBookmark(input: $input) {
            success
          }
        }
        `,
      variables: {
        input: {
          itemId,
        },
      },
    }
    const response: any = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(mutationBody),
    })
    const parsedResponse = await response.json()
    if (parsedResponse.errors) throw new Error(JSON.stringify(parsedResponse.errors))

    return parsedResponse
  } catch (err) {
    // Log this error to sentry but dont panic.
    console.error('Failed to remove bookmark from gsu-web', err)
    Sentry.captureException(err)
    return false
  }
}
